export default __webpack_public_path__ + "static/media/unauthorise-repair3.d976bcf9.png";